import { animate, style, transition, trigger } from '@angular/animations';

import { Component } from '@angular/core';

// Made the input an object since when used as a directive
// it will throw an error if not all the properties are set
export interface PriceGradePopupData {
  date: string;
  time: string;
  show: string;
  hide?: boolean;
  priceGradeSeatCounts: { priceGrade: string; seatCount: number }[];
}

@Component({
  imports: [],
  selector: 'ss-ticketing-hover-state',
  templateUrl: './hover-state.component.html',
  styleUrls: ['./hover-state.component.scss'],
  // Not sure how to import animations in standalone components
  // currently works in centerstage likely due to animation imported in app.module.ts
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ transform: 'translate3d(0,10px,0)', opacity: 0 }),
        animate(200, style({ transform: 'translate3d(0,0,0)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class HoverStateComponent {
  priceGradeData!: PriceGradePopupData;
  // Used to set location of popup since it is fixed
  left = 0;
  top = 0;
}
